import {WelfareResultService} from '../../../../service/welfare-result.service';
import {LifeProject} from '../../../../class/lifeproject/life-project';
import {NbCheckboxComponent} from '@nebular/theme';
import {Component, Input, ViewChild} from '@angular/core';

@Component({
  selector: 'app-base-lifeproject-base-editor',
  templateUrl: './life-project-base-editor.component.html',
  styleUrls: ['./life-project-base-editor.component.css']
})
export class LifeProjectBaseEditorComponent {

  @ViewChild('checkboxCover')
  coverCheckbox: NbCheckboxComponent;

  @Input()
  lifeProject: LifeProject;

  @Input()
  showCover = true;

  @Input()
  showApprove = true;

  constructor(private welfareService: WelfareResultService) {
  }

  isApproved(): boolean {
    if (this.getLifeProjectImpl()) {

      return this.getLifeProjectImpl().approved;
    }
    return false;
  }

  isIgnoreCover(): boolean {
    if (this.getLifeProjectImpl()) {
      return this.getLifeProjectImpl().computeCover;
    }
    return false;
  }

  setIgnoreCover(ignoreCover: boolean) {
    this.getLifeProjectImpl().computeCover = ignoreCover;
  }

  setApproved(approved: boolean) {
    this.getLifeProjectImpl().approved = approved;

    if (!approved) {
      this.setIgnoreCover(approved);
      this.coverCheckbox.checked = approved;
    }
  }

  get serviceProject() {
    return this.welfareService;
  }

  deleteProject() {
    this.welfareService.removeLifeProject(this.getLifeProjectImpl());
  }

  updateIgnoreCover(cover: boolean, checkboxApprove: NbCheckboxComponent) {
    if (!checkboxApprove.checked && cover) {
      // approve project
      checkboxApprove.checked = cover;
      this.setApproved(cover);
    }

    this.setIgnoreCover(cover);
  }

  getLifeProjectImpl(): LifeProject {
    return this.lifeProject;
  }
}
